import '@firebase/functions';
//# sourceMappingURL=index.esm.js.map
